/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_New_Font_Name_LabelInputs */

const en_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New font name`)
};

const fr_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la nouvelle police`)
};

const de_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Schriftartname`)
};

const it_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo nome del font`)
};

const ru_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое название шрифта`)
};

const es_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo nombre de fuente`)
};

const zh_cn2_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新字体名称`)
};

const ja_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいフォント名`)
};

const hi_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए फ़ॉन्ट का नाम`)
};

const pt_pt2_options_fonts_new_font_name_label = /** @type {(inputs: Options_Fonts_New_Font_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo nome de fonte`)
};

/**
* | output |
* | --- |
* | "New font name" |
*
* @param {Options_Fonts_New_Font_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_new_font_name_label = /** @type {((inputs?: Options_Fonts_New_Font_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_New_Font_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_new_font_name_label(inputs)
	if (locale === "de") return de_options_fonts_new_font_name_label(inputs)
	if (locale === "it") return it_options_fonts_new_font_name_label(inputs)
	if (locale === "ru") return ru_options_fonts_new_font_name_label(inputs)
	if (locale === "es") return es_options_fonts_new_font_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_new_font_name_label(inputs)
	if (locale === "ja") return ja_options_fonts_new_font_name_label(inputs)
	if (locale === "hi") return hi_options_fonts_new_font_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_new_font_name_label(inputs)
	return en_options_fonts_new_font_name_label(inputs)
});